import React, { useState, useEffect } from 'react';
import styles from './SignIn.scss';
import Input from '../Input/Input';
import Button from '../Button/Button';
import Spinner from '../Spinner/Spinner';
import { get, isEmpty, isNull } from 'lodash';
import { checkOneField } from '../validation';
import { PubSub } from '../../pubsub';
import classNames from 'classnames';
import { assign } from 'lodash';
import { getMInfo } from "../minfo";

const channel = new PubSub('pubsub_login_error');
window.lchannel = window.lchannel || channel;

const SignIn = props => {
  const [isLoading, setIsLoading] = useState(false);
  const [withUsername, setWithUsername] = useState(true);
  const [fields, setFields] = useState({ username: '', password: '' });
  const [params, setParams] = useState(Object.assign({ isBlocked: false }, props.params));
  const btn = React.createRef();
  const inpt = React.createRef();
  const pswrd = React.createRef();

  useEffect(() => {
    try {
      const oldUsername = localStorage.getItem('username');
      if (oldUsername.charAt(0) !== "{") {
        localStorage.removeItem('username');
      }
    } catch (error) {
    }

    const userData = JSON.parse(localStorage.getItem('username'));
    if (!isNull(userData)) {
      setWithUsername(false);
      setFields({ username: userData.user_name, password: '' })
    }

    window.addEventListener('resize', () => {
        let height = document.getElementById('widget0').clientHeight;
        let width = document.getElementById('widget0').clientWidth;

        const target = apiAdapter.url.replace('sso/auth/login-widget-router', '') !== 'https://i.zenit.ru' ? '*' : apiAdapter.url;
        window.top.postMessage(JSON.stringify({
          comrooxteampubsubid: 'com.rooxteam.login.adjustHeight',
          args: [height, width]
        }), target);
      }
    );
    //Todo remove timeout
    setTimeout(() => {
      let height = document.getElementById('widget0').clientHeight;
      let width = document.getElementById('widget0').clientWidth;

      const target = apiAdapter.url.replace('sso/auth/login-widget-router', '') !== 'https://i.zenit.ru' ? '*' : apiAdapter.url;
      window.top.postMessage(JSON.stringify({
        comrooxteampubsubid: 'com.rooxteam.login.adjustHeight',
        args: [height, width]
      }), target);
      withUsername && inpt.current !== null && inpt.current.focus();
    }, 400);
  }, [props]);

  const handleClick = () => {
    localStorage.removeItem('username');
    channel.publish({ type: 'ClearError' });
    //Todo remove timeout
    setTimeout(() => {
      let height = document.getElementById('widget0').clientHeight;
      let width = document.getElementById('widget0').clientWidth;

      const target = apiAdapter.url.replace('sso/auth/login-widget-router', '') !== 'https://i.zenit.ru' ? '*' : apiAdapter.url;
      window.top.postMessage(JSON.stringify({
        comrooxteampubsubid: 'com.rooxteam.login.adjustHeight',
        args: [height, width]
      }), target);
    }, 400);

    setWithUsername(true);
    setFields({ username: '', password: '' })
  };

  const isDisabled = () => {
    const usernameError = checkOneField(fields.username, 'username');
    return isEmpty(fields.username) || !isEmpty(usernameError) || isEmpty(fields.password);
  }

  const keyPressHandler = (event) => {
    if (event.key === 'Enter' && !isDisabled()) {
      btn.current.click();
    }
  };

  const handleChange = (event) => {
    const { value, name } = event.target;
    setFields({ ...fields, [name]: value.replace(/[\\\,\?\-\\\/\=:;№\(\)\+\{\}\[\]<>\|\`\~]/g, '') });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isDisabled()) {
      setIsLoading(true);
      (e.cancelBubble) ? e.cancelBubble : e.stopPropagation; //Погасили всплытие
      // получаем значение полей
      let username = fields.username;
      let password = fields.password;
      let gRecaptchaResponse = '';


      // если логин или пароль пустые отображаем ошибку
      if (username === "" || password === "") {

        // изменяем текущие состояние компонента
        setParams(assign(params, { errors_text: apiAdapter.getTranslation("empty_credentials", "errors") }))
      } else {
        let sendData = { username: username, password: password };

        if (typeof gRecaptchaResponse != 'undefined' && gRecaptchaResponse !== "") {
          sendData = { username: username, password: password, gRecaptchaResponse: gRecaptchaResponse };
        }

        sendData = { ...sendData, m_info: btoa(JSON.stringify(getMInfo())) }
        // делаем запрос на сервер и получем ответ
        apiAdapter.send(sendData, params.isSRP, (data) => {
          if (data.component === 'login') {
            console.log('login error', data.params.errors_text)
            channel.publish({ type: 'LoginError', params: data.params });
            setIsLoading(false)
          }
          // переключаем страницу
          props.route(data.component, data.params);
        });
      }// end if
    }

    return false;
  }

  const renderLoginFormWithoutUsername = () => {
    try {
      const oldUsername = localStorage.getItem('username');
      if (oldUsername.charAt(0) !== "{") {
        localStorage.removeItem('username');
      }
    } catch (error) {
    }

    const userData = JSON.parse(localStorage.getItem('username'));
    let welcome, withUsername;
    if (!isNull(userData)) {
      const givenName = get(userData, 'givenname', '');
      if (givenName) {
        welcome = `${givenName}, добрый день!`;
        withUsername = `Я не ${givenName}`;
      } else {
        welcome = 'Уважаемый клиент, добрый день!';
        withUsername = 'Другой клиент';
      }
    }
    const isMobile = /Mobile/i.test(navigator.userAgent);

    return (
      <div className={styles.Main}>
        {!isMobile && <div className={!isNull(userData) ? styles.TitleWithoutUsername : styles.Title}>Интернет-банк</div>}
        {!isNull(userData) ?
          <div className={styles.Text}>{welcome}</div>
          :
          <Input
            name='username'
            autoComplete='username'
            label="Логин"
            type='text'
            onChange={handleChange}
            onBlur={_ => _}
            value={fields.username}
            onKeyPress={keyPressHandler}
            id='username'
            autofocus={!isMobile}
            inputRef={inpt}
            testId="loginUsernameField"
            adaptiveIframe={true}
            defaultValue={''}
          />
        }
        <Input
          name='password'
          autoComplete='current-password'
          label="Пароль"
          type="password"
          onChange={handleChange}
          onBlur={_ => _}
          value={fields.password}
          onKeyPress={keyPressHandler}
          id='password'
          autofocus={!isMobile}
          testId="loginAgainPasswordField"
          adaptiveIframe={true}
          inputRef={pswrd}
          defaultValue={''}
        />
        <div className={styles.Wrapper}>
          <a href={'/registration'} rel="noopener noreferrer" target={'_top'}
             className={classNames(styles.MobileWrapperButton, styles.BtnRegistation)}>
            <Button transparent testId="loginRegisterButtonSecond" className={styles.MobileButton}>Регистрация</Button>
          </a>

          {isNull(userData) && <a href={'/registration'} rel="noopener noreferrer"  target={'_top'} className={styles.MobileWrapperButton}>
            <Button transparent testId="loginRegisterButton" className={styles.MobileButton}>Забыли?</Button>
          </a>}

          {!isNull(userData) &&
          <Button onClick={handleClick} transparent testId="loginAgainResetButton">{withUsername}</Button>}
          {isLoading
            ? <div className={styles.FlexRight}>
              <div className={styles.Circle}>
                <Spinner
                  className={classNames(styles.MainSpinner, styles.WhiteColor)}
                  IEStyle={styles.IESpinner}
                />
              </div>
            </div>
            : <Button
              buttonRef={btn}
              onClick={handleSubmit}
              testId="loginAgainEnterButton"
              className={isDisabled() ? styles.ButtonRegistrationMethodDisabled : styles.ButtonRegistrationMethod}
            >
              Войти
            </Button>
          }
        </div>
      </div>
    );
  };

  return (
    <div>
      {renderLoginFormWithoutUsername()}
    </div>

  )
}

export default SignIn;
